<div class="grid grid-cols-2 gap-3">
  @for (spec of availableSpecialties; track spec.key) {
    @let isSpecSelected = isSpecialtySelected(spec.key);
    <button
      type="button"
      class="flex items-center gap-3 p-3.5 rounded-xl text-left border transition-all cursor-pointer"
      [class.bg-primary-9]="isSpecSelected"
      [class.border-primary-9]="isSpecSelected"
      [class.text-white]="isSpecSelected"
      [class.shadow-md]="isSpecSelected"
      [class.bg-neutral-1]="!isSpecSelected"
      [class.dark:bg-neutral-2]="!isSpecSelected"
      [class.border-neutral-3]="!isSpecSelected"
      [class.dark:border-neutral-4]="!isSpecSelected"
      [class.text-neutral-12]="!isSpecSelected"
      [class.hover:border-neutral-5]="!isSpecSelected"
      [class.hover:bg-neutral-2]="!isSpecSelected"
      [class.dark:hover:bg-neutral-3]="!isSpecSelected"
      (click)="toggleSpecialty(spec.key)"
    >
      <div
        class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 transition-colors"
        [class.bg-white/20]="isSpecSelected"
        [class.bg-white]="!isSpecSelected"
        [class.dark:bg-neutral-3]="!isSpecSelected"
        [class.border]="!isSpecSelected"
        [class.border-neutral-3]="!isSpecSelected"
        [class.dark:border-neutral-4]="!isSpecSelected"
      >
        <mat-icon
          class="!w-4 !h-4 !text-lg"
          [class.!text-white]="isSpecSelected"
          [class.text-neutral-10]="!isSpecSelected"
        >
          {{ spec.icon }}
        </mat-icon>
      </div>
      <div class="flex-1 min-w-0">
        <span
          class="text-xs font-bold block truncate"
          [class.!text-white]="isSpecSelected"
          [class.text-neutral-12]="!isSpecSelected"
        >
          {{ spec.label }}
        </span>
      </div>
      @if (isSpecSelected) {
        <mat-icon class="!text-white !w-4 !h-4 !text-base shrink-0">check_circle</mat-icon>
      }
    </button>
  }
</div>
